import type { QueryClient } from "@tanstack/react-query";
import type { MessagesData } from "../lib/messages-cache";
import { conversationKeys } from "./conversation-keys";

/**
 * KAN-1468: правка ленты беседы из события хаба или ответа мутации. Если в этот момент лента перечитывается
 * (возврат во вкладку), ответ сервера — снимок, сделанный до правки, — затёр бы её. Перезапуск запроса отменяет
 * текущий, и следующий уже видит изменение.
 */
export function patchMessages(qc: QueryClient, conversationId: string, fn: (d: MessagesData | undefined) => MessagesData | undefined): void {
  const queryKey = conversationKeys.messages(conversationId);
  qc.setQueryData<MessagesData>(queryKey, fn);
  if (qc.isFetching({ queryKey }) > 0) void qc.invalidateQueries({ queryKey });
}
